import umiRequest, { RequestOptionsInit } from 'umi-request';
import { bus } from '@/utils/bus';
import { getCaptcha } from '@/services/captcha';
import { userInfoManager } from '@/utils/userInfo';

export interface ServerResponse<T = any> {
  code: number;
  message?: string;
  data: T;
}

export interface APIResult<T = any> {
  error?: Error;
  resp?: ServerResponse<T>;
}

export class ResponseError extends Error {
  public url?: string;
  public response?: any;
  public body?: any;
}

interface UploadResponseData {
  url: string; // URL of the uploaded image
  // Add other fields your backend might return
  [key: string]: any;
}

const DEFAULT_REQUEST_TIMEOUT_TIME = 300000;

const HTTP_STATUS_UNAUTHORIZED = 401;

const timeoutMessage = '请求超时，请稍后重试';

export const request = (url: string, options?: RequestOptionsInit) => {
  const promise: Promise<APIResult> = new Promise((resolve) => {
    const adminToken = localStorage.getItem('token') ?? '';
    umiRequest(url, {
      ...options,
      timeout: DEFAULT_REQUEST_TIMEOUT_TIME,
      timeoutMessage,
      // credentials: 'include',
      responseType: 'json',
      headers: { Authorization: adminToken },
      errorHandler: (error) => {
        console.error(error?.response);
        if (error?.response.status)
          if (error?.response.status === 471) {
            const verifyUuid: string = error.data.data?.verifyUuid;
            const verifyType: string = error.data.data?.verifyType || '102'; // 默认值为 '102'
            if (verifyUuid) {
              // 从全局用户管理器获取用户名
              const userName = userInfoManager.getCurrentUserName();

              getCaptcha({verifyUuid, verifyType, name: userName})
                .then(({data}: any) => {
                  bus.emit('captcha:show', {verifyUuid, verifyType, backgroundUrl: data.captchaInfo.backgroundUrl, centerUrl: data.captchaInfo.captchaUrl, rid: data.rid, name: userName});
                })
            }
          }
          if (error?.response?.status === HTTP_STATUS_UNAUTHORIZED) {
            // if (response?.status !== 200) { 才会进入 errorHandler }
            error.message = '登录已失效，正在刷新页面';
            const delay = 1500;
            setTimeout(() => {
              // window.location.reload();
            }, delay);
          } else if (error.message === 'Failed to fetch') {
            error.message = '网络异常，请检查网络';
          } else if (error.message === timeoutMessage) {
            // 什么也不做
          } else {
            error.message = '服务异常，请稍后重试';
          }
        return error;
      },
    })
      .then((resp: ServerResponse) => {
        resolve({ resp });
      })
      .catch((error: Error) => {
        resolve({ error: new Error(`请求失败：${error.message}`) });
      });
  });
  return promise;
};
